export default { 
 common: { 
 unit: 'USDT', 
 day: 'दिन', 
 week: 'सप्ताह', 
 save: 'सहेजें', 
 submit: 'सबमिट करें', 
 confirmtitle: 'ऑपरेशन निश्चित करें', 
 confirm: 'पुष्टि करें', 
 reset: 'रीसेट करें', 
 refresh: 'रिफ्रेश करें', 
 copy: 'कॉपी करें', 
 copysuccessful: 'कॉपी सफल', 
 modify: 'संशोधित करें', 
 binding: 'बंधन', 
 finished: 'पूरा हो गया', 
 canceled: 'रद्द किया गया', 
 cancel: 'रद्द करें', 
 all: 'सभी', 
 back: 'वापस', 
 loading: 'लोडिंग...', 
 nomore: 'सभी रिकॉर्ड', 
 errortxt: 'लोडिंग विफल', 
 loosing: 'रिफ्रेश करने के लिए रिलीज करें...', 
 pulling: 'रिफ्रेश करने के लिए नीचे खींचें...', 
 nodata: 'फिलहाल कोई रिकॉर्ड नहीं है', 
 buy: 'खरीदें', 
 buyup: 'ऊपर खरीदें', 
 buydown: 'नीचे खरीदें', 
 sell: 'बेचें', 
 forserver: 'कृपया ग्राहक सेवा से संपर्क करें', 
 total: 'कुल', 
 status1: 'समीक्षा पेंडिंग', 
 status2: 'पूर्ण', 
 status3: 'असफल', 
 paytype1:'TRC20', 
 paytype2: 'ERC20', 
 paytype3: 'वायर ट्रांसफर', 
 }, 
 footer: { 
 home: 'मुख्य पृष्ठ', 
 market: 'मार्केट', 
 exchange: 'कॉइन-कॉइन', 
 options: 'ऑप्शन', 
 assets:'सम्पत्ति', 
 change: 'ट्रांसफर', 
 recharge: 'कॉइन जमा करें', 
 withdrawal: 'कॉइन निकालें' 
 }, 
 home: { 
 menu1:'ऑप्शन ट्रेडिंग', 
 menu1desc: 'BTC/USDT आदि का समर्थन', 
 menu2: 'त्वरित रिचार्ज', 
 menu3: 'निकासी', 
 menu4: 'ऑनलाइन ग्राहक सेवा', 
 menu5: 'फ्लैश एक्सचेंज', 
 menu6: 'ऋण सहायता', 
 menu7: 'लॉक माइनिंग', 
 menu8: 'स्टेकिंग', 
 menu9: 'खाता ट्रांसफर', 
 ranktitle: 'बढ़त सूची', 
 name: 'नाम', 
 price: 'नवीनतम मूल्य', 
 risefall: 'उत्तरोत्तर पतन', 
 }, 
 register: { 
 register: 'पंजीकरण', 
 login: 'लॉगिन', 
 email: 'ईमेल', 
 phone: 'फोन नंबर', 
 accountplaceholder: 'खाता दर्ज करें', 
 emailplaceholder: 'ईमेल दर्ज करें', 
 phoneplaceholder: 'फोन दर्ज करें', 
 pwdplaceholder:'पासवर्ड दर्ज करें', 
 pwdplaceholder1:'पासवर्ड 6-20 अक्षर के किसी भी अक्षर-संख्या होनी चाहिए', 
 agepwdplaceholder: 'पासवर्ड दोबारा दर्ज करें', 
 agepwdplaceholder1: 'दो बार दर्ज की गई पासवर्ड अलग हैं', 
 invitecodeplaceholder: 'आमंत्रण कोड दर्ज करें', 
 remember: 'पासवर्ड याद रखें', 
 fotget: 'पासवर्ड भूल गए' 
 }, 
 market:{ 
 title: 'मार्केट', 
 all: 'सभी' 
 }, 
 member:{ 
 reputation:'सम्मान अंक', 
 identity_authentication:'पहचान प्रमाणीकरण', 
 under_review:'समीक्षा में', 
 certified:'प्रमाणित', 
 awaiting_certification:'प्रमाणन पेंडिंग', 
 binding_withdrawal_address: 'निकासी पता बंधन', 
 currently_selected_currency:'वर्तमान चयनित मुद्रा', 
 withdrawal_address:'निकासी पता', 
 sharing_link:'मेरी साझा लिंक', 
 my_promotion_code:'मेरा प्रचार कोड', 
 promotion_code:'प्रचार कोड', 
 system_message:'सिस्टम संदेश', 
 night_mode:'नाइट मोड', 
 security_center:'सुरक्षा केंद्र', 
 seted: 'सेट किया गया', 
 noset: 'सेट नहीं किया गया', 
 login_password:'लॉगिन पासवर्ड', 
 transaction_password:'निकासी पासवर्ड', 
 app_download:'ऐप डाउनलोड करें', 
 log_out:'लॉग आउट करें', 
 aboutus: 'वेबसाइट के बारे में' 
 }, 
 identity:{ 
 title: 'पहचान प्रमाणन', 
 name: 'नाम', 
 nameplaceholder: 'वास्तविक नाम दर्ज करें', 
 uploader: 'आईडी कार्ड फोटो अपलोड करें', 
 tip1: 'आईडी कार्ड का सामने का भाग अपलोड करें', 
 tip2: 'आईडी कार्ड का पीछे का भाग अपलोड करें' 
 }, 
 address: { 
 title: 'निकासी पता बंधन', 
 bType: 'वर्तमान चयनित मुद्रा', 
 address: 'निकासी पता', 
 addressplaceholder:'निकासी पता दर्ज करें', 
 }, 
 security:{ 
 title: 'सुरक्षा केंद्र', 
 modifypwd: 'लॉगिन पासवर्ड', 
 resetlegalpwd: 'निकासी पासवर्ड', 
 loginpwd: 'नया लॉगिन पासवर्ड', 
 pwdage: 'पासवर्ड पुष्टि करें', 
 loginpwdplaceholder:'वर्तमान लॉगिन पासवर्ड दर्ज करें', 
 loginnewpwdplaceholder: 'नया लॉगिन पासवर्ड दर्ज करें', 
 moneypwd: 'निकासी पासवर्ड दर्ज करें', 
 pwdageplaceholder:'पासवर्ड दोबारा दर्ज करें' 
 }, 
 trade:{ 
 title: 'कॉइन-कॉइन ट्रेडिंग', 
 price: 'मूल्य', 
 num: 'संख्या', 
 entrust: 'वर्तमान आदेश', 
 clinch: 'वास्तविक लेनदेन', 
 used: 'उपलब्ध', 
 buyed: 'खरीद सकते हैं', 
 amount: 'ट्रांजैक्शन राशि', 
 limitprice: 'सीमित मूल्य', 
 marketprice: 'बाजार मूल्य', 
 forprice: 'वर्तमान इष्टतम मूल्य पर लेनदेन करें', 
 errorMoney: 'उपलब्ध अवशेष अपर्याप्त हैं', 
 priceerror: 'आदेश मूल्य दर्ज करें', 
 numerror: 'आदेश संख्या दर्ज करें', 
 moneyerror: 'आदेश राशि दर्ज करें', 
 }, 
 assets:{ 
 allconvert:'कुल संपत्ति का मूल्य', 
 usenum: 'उपलब्ध', 
 freeze: 'फ्रीज', 
 convert: 'का मूल्य', 
 tab1:'संपत्ति', 
 tab11: 'कुल संपत्ति का मूल्य', 
 tab12: 'ऑप्शन का मूल्य', 
 tab13: 'धन का मूल्य', 
 tab14: 'क्वांटिफायेड का मूल्य', 
 tab2:'ऑप्शन', 
 tab21: 'ऑप्शन खाता', 
 tab3:'धन', 
 tab31:'धन खाता', 
 tab4:'क्वांटिफायेड', 
 tab41:'क्वांटिफायेड खाता', 
 tbhead1: 'वित्तीय रिकॉर्ड', 
 tbhead2: 'निकासी रिकॉर्ड', 
 tbhead3: 'जमा रिकॉर्ड', 
 tbhead4: 'ट्रांसफर रिकॉर्ड', 
 rcdnum: 'संख्या', 
 rcd: 'रिकॉर्ड', 
 rcdtime: 'समय' , 
 rcdstatus: 'स्थिति', 
 rcddesc: 'टिप्पणी', 
 rcdaddress: 'जमा पता' 
 }, 
 change:{ 
 title: 'ट्रांसफर', 
 from: 'से {name}', 
 to: 'को {name}', 
 frmtitle: 'ट्रांसफर की संख्या', 
 inputplaceholder: 'ट्रांसफर की संख्या दर्ज करें', 
 btntxt:'ट्रांसफर करें' 
 }, 
 recharge:{ 
 title: 'कॉइन जमा करें', 
 bType: 'वर्तमान मुद्रा', 
 address: 'जमा पता', 
 token: 'भुगतान प्रमाण पत्र', 
 tokenplaceholder: 'भुगतान प्रमाण पत्र अपलोड करें', 
 num: 'जमा की संख्या', 
 numplaceholder: 'संख्या दर्ज करें', 
 btn: 'समीक्षा के लिए सबमिट करें', 
 bankname: 'बैंक का नाम', 
 bankno: 'बैंक नंबर', 
 accountname: 'भुगतान खाता नाम', 
 bankaddress: 'बैंक का पता', 
 bankcode: 'बैंक ट्रांसफर कोड', 
 companyaddress: 'कंपनी का पता' 
 }, 
 withdrawal:{ 
 title:'कॉइन निकालें', 
 frmtitle1: 'संख्या', 
 frmplaceholder1: 'निकासी की संख्या {min} - {max} के बीच होनी चाहिए', 
 frmtitle2: 'निकासी पासवर्ड', 
 frmplaceholder2: 'निकासी पासवर्ड दर्ज करें', 
 getnum: 'प्राप्त राशि', 
 fee:'शुल्क', 
 btn: 'निकासी करें' 
 }, 
 exchangeb:{ 
 title: 'एक्सचेंज', 
 account: 'खाता', 
 btn: 'एक्सचेंज करें', 
 numerror: 'एक्सचेंज की संख्या दर्ज करें' 
 }, 
 option:{ 
 title: 'ऑप्शन', 
 typetitle: 'सेकंड कॉन्ट्रैक्ट', 
 listtitle: 'पोजीशन', 
 kline: 'केलाइन', 
 high: 'उच्च', 
 low: 'निम्न', 
 nums: '24 घंटे की मात्रा', 
 time: 'समय', 
 transaction: 'ट्रांजैक्शन मोड', 
 quantity: 'ओपन क्वांटिटी', 
 quantityerror: 'ओपन क्वांटिटी दर्ज करें', 
 times: 'ओपन टाइम', 
 times1: 'निपटान समय',
 account: 'खाता शेष', 
 buyup:'ऊपर खरीदें', 
 buydown: 'नीचे खरीदें', 
 tab1: 'पोजीशन सूची', 
 tab2: 'ऑर्डर रिकॉर्ड', 
 num: 'संख्या', 
 price1: 'खरीद मूल्य', 
 price2: 'विक्री मूल्य', 
 profitandloss: 'अनुमानित लाभ/घाटा', 
 profitandloss1: 'लाभ/घाटा', 
 countdown: 'काउंटडाउन', 
 waitfinish: 'सेटलमेंट पेंडिंग', 
 finishing: 'सेटलमेंट हो रहा है...', 
 finished: 'सेटलमेंट पूर्ण', 
 order_price: 'वर्तमान मूल्य', 
 order_cycle: 'चक्र', 
 order_type: 'प्रकार', 
 order_money: 'राशि', 
 order_time: 'पोजीशन', 
 order_get: 'लाभ', 
 order_btn: 'फिर से ऑर्डर दें' 
 }, 
 tradelst:{ 
 title: 'मेरी ऑर्डर', 
 tab1: 'ऑर्डर', 
 tab2: 'ट्रांजैक्शन पूर्ण', 
 tab3: 'रद्द किया गया', 
 usdtnum: '' 
 }, 
 loans:{ 
 title: 'ऋण सहायता', 
 order_tab: 'ऋण ऑर्डर', 
 pro_tab: 'ऋण उत्पाद', 
 
 Institution:'ऋण देने वाली संस्था', 
 Amount: 'राशि', 
 DailyInterest:'दैनिक ब्याज दर', 
 RepaymentPeriod:'प्रतिफल अवधि', 
 Application: 'ऋण आवेदन करें', 
 orderno: 'ऑर्डर नंबर', 
 AllInterest: 'कुल ब्याज', 
 RepaymentDate:'प्रतिफल तिथि', 
 RepaymentMethod: 'प्रतिफल विधि', 
 Onetime: 'एक बार', 
 Expected_loan_amount:'अपेक्षित ऋण राशि', 
 Expected_loan_amounterror:'ऋण राशि {min} - {max} की सीमा में होनी चाहिए', 
 imgplaceholdr: 'क्रेडिट लोन (कृपया सुनिश्चित करें कि चित्र स्पष्ट रूप से दिखाई दे)', 
 icon1: 'सब्बोत का सामने वाला भाग अपलोड करें', 
 icon2: 'सब्बोत का पीछे वाला भाग अपलोड करें', 
 icon3: 'सब्बोत को हाथ में रखकर अपलोड करें', 
 status1: 'आवेदन पेंडिंग', 
 status2: 'आवेदन स्वीकृत', 
 status3: 'आवेदन असफल', 
 }, 
 lockming:{ 
 title: 'लॉक माइनिंग', 
 order_tab: 'माइनिंग ऑर्डर', 
 pro_tab: 'माइनिंग मार्केट', 
 locknum: 'न्यूनतम लॉक मात्रा', 
 getforday: 'रिटर्न/दिन', 
 days: 'दिन', 
 estimation: 'अनुमानित लाभ', 
 real: 'प्राप्त लाभ', 
 balance: 'वॉलेट शेष', 
 nums: 'लॉक मात्रा', 
 tolockming: 'लॉक करें', 
 stime: 'शुरू होने का समय', 
 etime: 'समाप्त होने का समय', 
 }, 
 transfer:{ 
 title: 'खाता ट्रांसफर', 
 searchtxt: 'प्राप्तकर्ता खाता दर्ज करें', 
 ReceivingAccount: 'प्राप्तकर्ता खाता जानकारी', 
 toaccount: 'खाता', 
 confirmtxt: 'कृपया प्राप्तकर्ता खाता की पुष्टि करें', 
 confirmedtxt: 'प्राप्तकर्ता खाता की पुष्टि की गई है', 
 numtxt: 'ट्रांसफर की संख्या', 
 numerror: 'ट्रांसफर की संख्या दर्ज करें', 
 fee: 'आंतरिक ट्रांसफर पर शुल्क नहीं', 
 ArrivalTime: 'पहुंचने का समय', 
 Immediately: 'तुरंत पहुंच जाएगा', 
 realnum: 'वास्तविक प्राप्त राशि', 
 btn: 'ट्रांसफर की पुष्टि करें', 
 
 transfering: 'ट्रांसफर हो रहा है', 
 orderNo: 'ऑर्डर नंबर', 
 stime: 'ट्रांसफर का समय', 
 etime: 'पहुंचने का समय', 
 receiving: 'प्राप्तकर्ता खाता', 
 type: 'मुद्रा', 
 num: 'ट्रांसफर की संख्या', 
 arrivalnum: 'प्राप्त राशि' 
 }, 
 staking:{ 
 title: 'स्टेकिंग', 
 record: 'रिकॉर्ड', 
 getforyear: 'सलाना रिटर्न का अनुमान', 
 time: 'निवेश अवधि', 
 snum: 'न्यूनतम निवेश', 
 snumerror: 'न्यूनतम निवेश दर्ज करें', 
 snumerror1: 'न्यूनतम निवेश {num} से कम नहीं हो सकता है', 
 join: 'तुरंत भाग लें', 
 opentime: 'पोजीशन का समय', 
 money: 'निवेश राशि', 
 days: 'चक्र', 
 recordget: 'सलाना रिटर्न', 
 gets: 'लाभ', 
 stime: 'शुरू की तारीख', 
 etiem: 'समाप्त की तारीख', 
 redeemStaking: 'रिडीम करें', 
 status0: 'स्टेकिंग में', 
 status1: 'ऑर्डर समाप्त', 
 status2: 'ऑर्डर रिडीम', 
 }, 
 bank:{ 
 title: 'बैंक कार्ड बांधाएं', 
 bankName: 'बैंक का नाम', 
 bankNameError: 'बैंक का नाम दर्ज करें', 
 usrName: 'कार्डधारक का नाम', 
 usrNameError: 'कार्डधारक का नाम दर्ज करें', 
 cardCode: 'बैंक कार्ड नंबर', 
 cardCodeError: 'बैंक कार्ड नंबर दर्ज करें', 
 towallet: 'वॉलेट में निकालें', 
 tobank: 'बैंक खाते में निकालें', 
 sendcode: 'ओटीपी कोड भेजें', 
 sended: '{num} सेकंड बाद दोबारा भेजें', 
 verify_code: 'ईमेल ओटीपी कोड दर्ज करें' 
 },
 other:{
        welcome: 'नमस्ते, {name} में आपका स्वागत है',
    homeaboutustitle: 'विश्व की अग्रणी ऑल-इन-वन डिजिटल एसेट ट्रेडिंग प्लेटफॉर्म',
    homeaboutustitle1: 'सुरक्षा गारंटी',
    homeaboutusdesc1: 'शीर्र्ष सुरक्षा संस्थानों के सााथ सहयोग से सुरक्षित और कुशल लेनदेन सुनिश्चित',
    homeaboutustitle2: '24x7 ग्राहक सेवा',
    homeaboutusdesc2: '24 घंटे ऑनलाइन ग्राहक सहायता, आपकी आवश्यकताओं का तुरंत जवााब',
    homeaboutustitle3: 'वैश्विक कवरेज',
    homeaboutusdesc3: '205 देशों/क्षेत्रों को कवर करने वाला अंतर्राष्ट्रीय समुदाय, 11 भाषाओं का समर्थन, 19 राष्ट्रीय/क्षेत्रीय समुदाय, 50 लाख पंजीकृत उपयोगकर्ता',
    totrade: 'ट्रेडिंग शुरू करें',
    toregister: 'डििजििटल मुद्रा यात्रा प्रारंभ करें',
    yingli: 'आज का लाभ',
    kuisun: 'आज की हानि',
    agree: 'मैंने पढ़ लिया और स्वीकार किया',
    useragreement: 'उपयोगकर्ता समझौता',
    account: 'खाता',
    pwd: 'पासवर्र्ड',
    toregister1: 'अभी तक पंजीकृत नहीं',
    loginbtn: 'लॉग इन',
    registerbtn: 'अभी पंजीकृत करें',
    tologin: 'पहले से खाता है? पंजीकरण पर जाएं',
    allrevenue: 'कुल आय',
    stakingcount: 'स्टेकिंग ऑर्डर',
    stakingamount: 'स्टेकिंग राशि',
    todayincome: 'आज का अनुमानित'

 }
}
